import React, { Component } from 'react';
import { Row, Col, Typography } from 'antd';
import LoginForm from './LoginForm';
import LoginLogoOrange from '../../assets/Logos/vrsafety-login-logo-orange.png';
import LoginLogoTeal from '../../assets/Logos/vrsafety-login-logo-teal.png';
import PoweredWithLove from '../../assets/PoweredWithLove/PoweredWithLove';
import { Link } from 'react-router-dom';

const { Title } = Typography;

let COLOR_STYLE = 'teal';
class Login extends Component<any, any> {
    _isMounted = false;
    constructor(props: any) {
        super(props);
        this.state = {};
        if (this.props.location.pathname.includes('management')) {
            COLOR_STYLE = 'orange';
        }
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        return (
            <div className="ant-card loginCard">
                <Row>
                    <Col span={12} style={{ textAlign: 'center' }}>
                        <button className="StrippedButton">
                            <Link to={`/`}>
                            <img
                                src={
                                    COLOR_STYLE == 'teal'
                                        ? LoginLogoTeal
                                        : LoginLogoOrange
                                }
                                alt="Logo"
                                style={{ height: '200px' }}
                                />
                            </Link>
                        </button>
                    </Col>
                    <Col span={12}>
                        <LoginForm location={this.props.location} />
                    </Col>
                </Row>
                <Row
                    style={{
                        textAlign: 'center',
                        color: '#fff',
                        padding: '0px',
                        margin: '0px',
                    }}
                >
                    <PoweredWithLove />
                </Row>
            </div>
        );
    }
}

export default Login;
